// extracted by mini-css-extract-plugin
module.exports = {"price-skeleton":"gwg-price-display_price-skeleton__6lDYp"};